/**
 * Converts a FullTicker (e.g. "MU:USA") to a URL-friendly slug ("MU-USA").
 * Replaces ':' with '-' so the URL reads /stock/MU-USA instead of /stock/MU%3AUSA.
 */
export function tickerToSlug(fullTicker: string): string {
  return fullTicker.replace(/:/g, '-');
}

/**
 * Encodes a stock slug for use in URL paths and XML sitemaps.
 * Required for tickers like M&M:IND → M&M-IND where raw "&" breaks XML.
 */
export function stockSlugToPath(slug: string): string {
  return `/stock/${encodeURIComponent(slug)}`;
}

export function stockUrlFromFullTicker(fullTicker: string, baseUrl: string): string {
  return `${baseUrl}${stockSlugToPath(tickerToSlug(fullTicker))}`;
}

/**
 * Converts a URL slug back to a FullTicker.
 * Replaces the LAST '-' with ':' so "BRK-B-USA" → "BRK-B:USA".
 * If no '-' is found, returns the slug as-is (handles tickers like "GLBL.B").
 */
export function slugToTicker(slug: string): string {
  const decoded = decodeURIComponent(slug);
  const lastDash = decoded.lastIndexOf('-');
  if (lastDash === -1) return decoded;
  return decoded.slice(0, lastDash) + ':' + decoded.slice(lastDash + 1);
}
